import React, { useEffect, useState } from "react";
import { Form, Input, Button, Select,DatePicker,Row, Col,Image,Card, Alert, Spin, message,PageHeader } from 'antd';
import {onecodeAPI} from "../AppConfig";
import _ from "lodash";
import moment, { now } from "moment";
import { LoadingOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from "react-router-dom";
message.config({
  top: '25vh',
  duration: 2,
});


const antIcon = <LoadingOutlined style={{ fontSize: 18, color: '#fff', marginRight: 10 }} spin />;

const { Option } = Select;
const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 12,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

export default (props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false)
  const [formSubmitLoading, setFormSubmitLoading] = useState(false);
  const [mobileNumber,setMobileNumber] = useState("");
  const [isExpired,setIsExpired] = useState(false)
  let location = useLocation();


  let motorDetails = _.get(location,"state.rcdetails");
  let brandUrl = _.get(location,"state.brandUrl");

    useEffect(() => {
        form.setFieldsValue({
            ...motorDetails,
            insuranceExpiryDate: motorDetails?.insuranceExpiryDate ? moment(motorDetails.insuranceExpiryDate).format("DD/MM/YYYY") : null,
            vehicleManufacturedDate:motorDetails?.vehicleManufacturedDate ? moment(motorDetails.vehicleManufacturedDate).format("MM/YYYY") : null
        });
        let insDate = moment(motorDetails?.insuranceExpiryDate).add(1,"days");
    let today = moment();
    let insuranceExpireDays = insDate.diff(today,'days');
        if(!(insuranceExpireDays <= 0 || insuranceExpireDays < 60)){
            setIsExpired(true);
        }
    }, [])

    // console.log(moment());

  const insuranceExpiryContent = () => {

    let insDate = moment(motorDetails?.insuranceExpiryDate).add(1,"days");
    let today = moment();
    let insuranceExpireDays = insDate.diff(today,'days');
    if(insuranceExpireDays <= 0){
        return <p style = {{color : "#D10000"}}>The insurance policy of your customer has already expired. Please renew it now!</p>
    }else if(insuranceExpireDays < 60){
        return <p style = {{color : "#D10000"}}>The insurance policy of your customer will expire soon. Please renew it now!</p>
    }else {
        // setIsExpired(true);
        return <p style = {{color : "#D10000"}}>Current insurance policy is not expiring within 60 days. We will remind you once it is eligible for renewal.</p>
    }

  }

  const onFinish = (values) => {
    if(brandUrl && !brandUrl.includes("null")){
        window.location.replace(brandUrl);
    }
  };

  return (
      <div>
          <PageHeader
            className="site-page-header"
            onBack={() => null}
            title="2 Wheeler insurance"
            style = {{background : "#6c63ff"}}
        />
      

        <Row>
          
          <div style = {{padding : "10px 20px"}}>
          <Spin spinning = {loading}>
            <div>
                {insuranceExpiryContent()}
            </div>
            <Form form={form} name="control-hooks" onFinish={onFinish} >
              <Form.Item
                name="ownerName"
                label = "Name of the Owner"
                style = {{borderRadius : 10}}
              >
                <Input size = "large" 
                  placeholder="Full Name" 
                  style = {{borderRadius : 6}}
                  readOnly = "true"
                  />
              </Form.Item>

                <div style = {{textAlign : "center"}}>
                    <p>INSURANCE DATA</p>
                </div>

              <Form.Item
                name="policyNumber"
                label = "Policy Number"
              >
                <Input 
                size = "large" 
                placeholder="Phone Number" 
                readOnly = "true"
                style = {{borderRadius : 6}}/>
              </Form.Item>

              <Form.Item
                name="insuranceCompany"
                label = "Insurance Company Name"
                style = {{borderRadius : 10}}
              >
                <Input size = "large" 
                  placeholder="Insurance Company Name" 
                  style = {{borderRadius : 6}}
                  readOnly = "true"
                  />
              </Form.Item>


              <Form.Item 
                name="insuranceExpiryDate"
                label = "Expiry Date"
                >
                    <Input 
                    size = "large" 
                  placeholder="Expiry Date (DD-MM-YYYY)" 
                  style = {{borderRadius : 6}}
                  readOnly = "true"
                  />
                  
              </Form.Item>

              <div style = {{textAlign : "center"}}>
                    <p>VECHILE DATA</p>
                </div>

                <Form.Item
                name="vehicleMakerDescription"
                label = "Maker Description"
                style = {{borderRadius : 10}}
              >
                <Input size = "large" 
                  placeholder="Maker Description " 
                  style = {{borderRadius : 6}}
                  readOnly = "true"
                  />
              </Form.Item>

              <Form.Item
                name="vehicleMakerModel"
                label = "Maker Model"
                style = {{borderRadius : 10}}
              >
                <Input size = "large" 
                  placeholder="Maker Model" 
                  style = {{borderRadius : 6}}
                  readOnly = "true"
                  />
              </Form.Item>


              <Form.Item 
                name="vehicleManufacturedDate"
                label = "Manufactured Date"
                >
                    <Input 
                    size = "large" 
                  placeholder="Manufactured Date (YYYY-MM)" 
                  style = {{borderRadius : 6}}
                  readOnly = "true"
                  />
              </Form.Item>
            
              <Form.Item {...tailLayout} style ={{display : "inline-block",marginLeft : 0}} block>
                <Button type="primary" htmlType="submit" style={{marginLeft : 0,background : "#6c63ff"}}>
                {formSubmitLoading && <Spin indicator={antIcon} />}
                {isExpired ?   "Check OD Cover (If Applicable)" : "Check insurance quotes"}
                </Button>
              </Form.Item>
            </Form>
            </Spin>
    </div>

    </Row>
    </div>
  );
};